import React, { useState } from 'react';
import '../styles/Services.css';
import ContactForm from './Form';
import courseData from './courseData';
import nailImg from '../components/icons/capadesignnail.jpg';
import browImg from '../components/icons/capadesignbrow.png';
import makeupImg from '../components/icons/capamaquiagem.png';

// Mapear as imagens dos cursos para suas respectivas imagens
const courseImages = {
  naildesign: nailImg,
  browdesign: browImg,
  makeup: makeupImg
};

const Services = () => {
  const [selectedCourseId, setSelectedCourseId] = useState('naildesign');
  const [selectedModality, setSelectedModality] = useState('EAD'); // Adicionando controle para modalidades

  // Função para selecionar um curso
  const handleCourseSelect = (id) => {
    setSelectedCourseId(id);
    setSelectedModality('EAD'); // Resetar modalidade para EAD ao trocar curso
  };

  // Função para selecionar a modalidade dentro de um curso
  const handleModalitySelect = (modality) => {
    setSelectedModality(modality);
  };

  // Encontrar o curso e a modalidade selecionada
  const selectedCourse = courseData.find(course => course.id_curso === selectedCourseId);
  const selectedCourseModality = selectedCourse?.modalities.find(mod => mod.name === selectedModality);

  return (
    <div className="services" id="services">
      <h2>Conheça nossos cursos profissionalizantes</h2>
      <div className="course-maininfo">
        <h3>
            Você já imaginou viver do que ama? <br/><br/> Na Academia Girassol, isso é possível.
        </h3>
          <p>
          Com uma metodologia flexível, moderna e envolvente, nossos cursos unem teoria online de fácil acesso com práticas presenciais guiadas por profissionais experientes, tudo isso pensado para garantir sua formação completa e atualizada para o mercado de beleza.
          <p>
          Seja você uma iniciante cheia de sonhos ou uma profissional em busca de aperfeiçoamento, aqui você encontra o apoio, o conhecimento e a motivação certos para crescer. Aqui cada aula é um passo a mais rumo à sua independência, ao seu reconhecimento e à conquista dos seus objetivos.
          </p>
          </p>
          <h3>Mais do que um curso, é o início de uma nova história. </h3>
          <p>
          Chegou a hora de investir em você e construir uma carreira sólida com propósito, beleza e rentabilidade. <br/> <br/>
          Escolha seu curso abaixo e comece hoje mesmo a trilhar o caminho do sucesso!
        </p>
      </div>

      {/* Cards de seleção de cursos */}
      <div className="card-container">
        {courseData.map(course => (
          <div
            key={course.id_curso}
            className={`course-card ${selectedCourseId === course.id_curso ? 'active' : ''}`}
            onClick={() => handleCourseSelect(course.id_curso)}
          >
            <h3>{course.title}</h3>
            <img src={courseImages[course.id_curso]} alt={course.title} />
            <br/>
          </div>
        ))}
      </div>

      {/* Detalhes do curso selecionado */}
      {selectedCourse && selectedCourseModality && (
        <div className="course-details">
          <h1>{selectedCourse.title}</h1>

          {/* Modalidades */}
          <div className="course-modality">
            <h4>Modalidades disponiveis:</h4>
            <div className="modality-buttons">
              {selectedCourse.modalities.map((mod, index) => (
                <button
                  key={index}
                  onClick={() => handleModalitySelect(mod.name)}
                  className={selectedModality === mod.name ? 'modality-btn active' : 'modality-btn'}
                >
                  {mod.name}
                </button>
              ))}
            </div>
          </div>

          {/* Benefícios do curso */}
          <ul className="course-benefits">
            {selectedCourseModality.details.map((item, index) => (
              <li key={index} className={item.available ? 'available' : 'unavailable'}>
                {item.text}
              </li>
            ))}
          </ul>

          {/* Preço do curso */}
          <p className="course-price">{selectedCourseModality.price}</p>

          {/* Links do curso */}
          <div className="course-links">
            <a href={selectedCourseModality.btn_link} target="_blank" rel="noopener noreferrer" className="cta-btn">
              Comprar Agora!
            </a>
            <br /><br />
            <a href={selectedCourseModality.course_link} target="_blank" rel="noopener noreferrer" className="moreinfo">
              Saiba mais aqui!
            </a>
          </div>
        </div>
      )}

      {/* Contato */}
      <div className="contact-call">
        <h3>Ficou alguma dúvida?</h3>
        <h2>Fale conosco!</h2>
      </div>

      <ContactForm />
    </div>
  );
};

export default Services;